import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import { TextFieldWithLabel } from 'Components/TextField'
import * as AppRoutes from 'Pages/Routes'
import { sendPost } from 'hooks/use-fetch'

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function ForgotPasswordPage (): JSX.Element {
  const [email, setEmail] = useState<string>('')
  const [validationError, setValidationError] = useState<string | null>(null)
  const [submitted, setSubmitted] = useState<boolean>(false)

  const submit = async (): Promise<void> => {
    if (!EMAIL_PATTERN.test(email)) {
      setValidationError('Please enter a valid email address.')
      return
    }

    setValidationError(null)
    await sendPost('/Account/ForgotPassword', { email })
    setSubmitted(true)
  }

  return (
    <Box sx={{ bgcolor: '#fff', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2 }}>
      <Box sx={{ width: '100%', maxWidth: '480px', textAlign: 'center' }}>
        {submitted
          ? (
            <>
              <Typography variant="h4" component="h1" sx={{ mb: 2 }}>Check your email</Typography>
              <Typography sx={{ color: 'text.secondary', mb: 3 }} data-testid="forgot-password-confirmation">
                If an account exists for that email, we&apos;ve sent a link to reset your password.
              </Typography>
              <Link to={AppRoutes.LOGIN}>Return to login</Link>
            </>
            )
          : (
            <form noValidate onSubmit={event => { event.preventDefault(); void submit() }}>
              <Typography variant="h4" component="h1" sx={{ mb: 1 }}>Forgot your password?</Typography>
              <Typography sx={{ color: 'text.secondary', mb: 3 }}>
                Enter your email and we&apos;ll send you a link to reset your password.
              </Typography>

              <TextFieldWithLabel
                label="Email"
                name="email"
                type="email"
                value={email}
                onChange={event => { setEmail(event.target.value) }}
                maxWidth="100%"
                placeHolder="Enter your email"
                dataTestId="forgot-password-email"
              />

              {validationError != null && (
                <Typography sx={{ color: 'error.main', mt: 1 }} data-testid="forgot-password-validation-error">
                  {validationError}
                </Typography>
              )}

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{ textTransform: 'none', mt: 3 }}
                data-testid="forgot-password-submit"
              >
                Send Recovery Link
              </Button>

              <Box sx={{ mt: 2 }}>
                <Link to={AppRoutes.LOGIN}>Return to login</Link>
              </Box>
            </form>
            )}
      </Box>
    </Box>
  )
}
